import * as React from 'react';
import { SendPhoneNumberModalContent } from '../../../components/Modals';
import { useDeviceType } from '@cian/ui-kit';
import { useReferrerAppDispatch } from '../../../hooks';
import { requestPhoneValidationCode } from '../../../thunks/referrer';
import { useSelector } from 'react-redux';
import { selectPageModal, selectUserPhone } from '../../../selectors';
import { formatPhoneStringToInput, isPhoneValid } from '../../../utils/formatPhoneString';

export const SendPhoneNumberModal: React.FC = () => {
  const dispatch = useReferrerAppDispatch();

  const userPhone = useSelector(selectUserPhone);
  const { error } = useSelector(selectPageModal);

  const [phoneValue, setPhoneValue] = React.useState(formatPhoneStringToInput(userPhone));
  const [isBtnDisabled, setIsBtnDisabled] = React.useState<boolean>(false);

  const deviceType = useDeviceType();
  const isPhone = deviceType === 'phone';

  const handlePhoneChange = React.useCallback((value: string) => {
    setPhoneValue(value);
  }, []);

  const handleSendPhoneClick = React.useCallback(async () => {
    dispatch(requestPhoneValidationCode(phoneValue));
  }, [dispatch, phoneValue]);

  React.useEffect(() => {
    const isUserPhoneValid = isPhoneValid(phoneValue);

    setIsBtnDisabled(!isUserPhoneValid);
  }, [phoneValue]);

  return (
    <SendPhoneNumberModalContent
      isPhone={isPhone}
      isDisable={isBtnDisabled}
      phone={phoneValue}
      onPhoneChange={handlePhoneChange}
      onSendPhoneClick={handleSendPhoneClick}
      error={error}
    />
  );
};
